import {
  INVESTMENT_DATE_NOT_DEFINED_FEEDBACK,
  MIN_EFFECTIVE_DATE_FEEDBACK,
} from 'pages/CapTable/cap-table/data/validationsConstants';
import { gridShortDate } from 'utilities';
import { DivRateCell } from '../components/dividend-rate-ledger/config/types';
import { LiqPrefCell } from '../components/liquidation-preference-ledger/liq-pref-ledger-table-config/liqPrefLedgerValidations.props';

const FIRST_COLUMN_LETTER = 'A';

type ValidateEffectiveDateWithInvestmentDate<T extends LiqPrefCell | DivRateCell> = {
  cell: T;
  investmentDate: string | null | undefined;
  removeFeedbackFromCell?: (cell: T, feedback: string) => void;
  addFeedbackFromCell?: (cell: T, feedback: string) => void;
};

const validateEffectiveDateWithInvestmentDate = <T extends LiqPrefCell | DivRateCell>(
  params: ValidateEffectiveDateWithInvestmentDate<T>
) => {
  const { cell, addFeedbackFromCell, removeFeedbackFromCell, investmentDate } = params;
  const { value, columnLegend } = cell;
  if (investmentDate && columnLegend === FIRST_COLUMN_LETTER) {
    const isValid = gridShortDate(value as string) === gridShortDate(investmentDate);
    if (!isValid) {
      addFeedbackFromCell?.(cell, MIN_EFFECTIVE_DATE_FEEDBACK);
    } else {
      removeFeedbackFromCell?.(cell, MIN_EFFECTIVE_DATE_FEEDBACK);
    }
  }
  if (!investmentDate) {
    addFeedbackFromCell?.(cell, INVESTMENT_DATE_NOT_DEFINED_FEEDBACK);
  } else {
    removeFeedbackFromCell?.(cell, INVESTMENT_DATE_NOT_DEFINED_FEEDBACK);
  }
};

export default validateEffectiveDateWithInvestmentDate;
